import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/Config';
import LoadingForAll from '../../../Pages/LoadingForAll';
import './AdminLoginForm.css';

function AdminLoginForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginErr, setLoginErr] = useState('');
    const [load, setLoad] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoginErr('');
        setLoad(true);

        try {
            const auth = getAuth();
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            
            // Check if user is admin
            const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
            
            if (userDoc.exists() && userDoc.data().isAdmin) {
                // User is admin, redirect to admin panel
                navigate('/admin-home');
            } else {
                // User is not admin, sign them out and show error
                await auth.signOut();
                setLoginErr('Access denied. Admin privileges required.');
            }
        } catch (error) {
            setLoginErr(error.message);
        } finally {
            setLoad(false);
        }
    };

    const getErrorMessage = (code) => {
        switch (code) {
            case 'auth/invalid-email':
                return 'Invalid email address';
            case 'auth/user-disabled':
                return 'Account disabled';
            case 'auth/user-not-found':
                return 'No account found with this email';
            case 'auth/wrong-password':
                return 'Incorrect password';
            case 'auth/too-many-requests':
                return 'Too many attempts. Try again later';
            default:
                if (code.includes('Access denied')) {
                    return code;
                }
                return 'Login failed. Please try again';
        }
    };

    return (
        <section className="vh-100 admin-login-section">
            <div className="container-fluid h-custom">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-md-9 col-lg-6 col-xl-5">
                        <div className="admin-login-image">
                            <h2 className="text-center mb-4">Admin Panel</h2>
                            <p className="text-center">Access the administrative dashboard</p>
                        </div>
                    </div>
                    <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                        <form onSubmit={handleSubmit}>
                            <div className="divider d-flex align-items-center my-4">
                                <p className="text-center fw-bold mx-3 mb-0 admin-login-title">
                                    Admin Login
                                </p>
                            </div>
                            {loginErr && (
                                <div className="alert alert-danger" role="alert">
                                    {getErrorMessage(loginErr)}
                                </div>
                            )}
                            
                            {/* Email input */}
                            <div className="form-outline mb-4">
                                <input 
                                    type="email" 
                                    id="adminEmail" 
                                    className="form-control form-control-lg" 
                                    name="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter admin email address" 
                                    required
                                />
                                <label className="form-label" htmlFor="adminEmail">Admin Email</label>
                            </div>

                            {/* Password input */}
                            <div className="form-outline mb-3">
                                <input 
                                    type="password" 
                                    id="adminPassword" 
                                    className="form-control form-control-lg" 
                                    name="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter admin password" 
                                    required
                                />
                                <label className="form-label" htmlFor="adminPassword">Admin Password</label>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg admin-login-btn"
                                    disabled={load}
                                >
                                    {load ? 'Logging in...' : 'Admin Login'}
                                </button>
                                {load && <LoadingForAll />}
                            </div>
                            
                            <div className="text-center mt-3">
                                <p className="small">
                                    <a href="/" className="text-decoration-none">← Back to Home</a>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AdminLoginForm; 